module.exports = __webpack_public_path__ + "img/rightBg.1ca32ffa.png";